<template>
  <div class="container-indicators">
    <div class="box box-carousel">
      <v-carousel height="auto" cycle :show-arrows="true" hide-delimiters>
        <v-carousel-item v-for="(item, i) in this.imagesArray" :key="i">
          <div class="item">
            <img class="custom" :src="item.src" />
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
    <div class="box box-text">
      <div class="title">
        <span>PROYECTO CARRUSEL-{{ this.nameBranch }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { loaderDone, loaderStart } from "@/services/LoaderService";
export default {
  data() {
    return {
      nameBranch: "Sin sucursal",
      imagesArray: []
    };
  },
  methods: {
    ...mapActions("dashboard", ["getImagesKPI"]),
    ...mapActions("checklist", ["getBranch"]),
    async callGetImagesKPI() {
      await this.getImagesKPI(this.userBranch);
      this.imagesArray = this.imagesKPI;
    },
    async getNameSucursal() {
      await this.getBranch();
      const branchList = this.branchs || [];
      const branch = branchList.find(el => el.value === this.userBranch);
      if (branch) this.nameBranch = branch.title;
      if (this.userAccess["admin-kpi"]) this.nameBranch = "Administrador";
    }
  },
  computed: {
    ...mapState("user", ["data", "userBranch", "userAccess"]),
    ...mapState("dashboard", ["imagesKPI"]),
    ...mapState("checklist", ["branchs"])
  },
  async beforeMount() {
    loaderStart();
    await this.callGetImagesKPI();
    await this.getNameSucursal();
    loaderDone();
  }
};
</script>
<style scoped>
.container-indicators {
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.box {
  text-align: center;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.box-carousel {
  flex: 1;
}

.box-text {
  height: 60px;
}

.title {
  display: flex;
  width: 100%;
  padding: 3rem;
  text-align: left;
  align-content: center;
  bottom: 0px;
}
.title span {
  font-size: 34px;
}
.custom {
  width: auto;
  height: auto;
  max-height: 100%;
}
.item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
